import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

const buildMarkerTemplate = (url, color, index) => {
  const hasSpaces = url.includes(" ");
  const imageUrl = hasSpaces ? url.replace(/\s/g, "%20") : url;

  const colorMarker = color?.replace(/^#?([a-fA-F0-9]{6}).*$/, '#$1') || '#9ecc3b';

  const template = document.createElement("template");
  template.innerHTML = `
    <svg class="default-3d-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="50">
      <defs>
        <clipPath id="circleClip">
          <circle cx="8" cy="6" r="5" />
        </clipPath>
      </defs>

      <!-- Pin shape path with colored fill -->
      <path
        d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z
           M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3S9.656,8,8,8z"
        fill="${colorMarker}" />

      <!-- White circle inside -->
      <circle cx="8" cy="6" r="5" fill="#FFFFFF" />
      <image xlink:href=${imageUrl ? imageUrl
      : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4" y="1.5" width="8"
              height="9" clip-path="url(#circleClip)"></image>

      <!-- Index number centered in the white circle -->
      <text x="8" y="6" text-anchor="middle" font-size="4" fill="#333" font-weight="bold" dominant-baseline="middle">
        ${index + 1}
      </text>
    </svg>
  `;
  return template;
};

const ThreeDMarkerDetails = (props) => {

  let markerRef

  async function mapFunction() {

    const gmpMapElement = document.querySelector('gmp-map-3d');

    if (!gmpMapElement) return;

    // Delay ensures canvas is rendered
    const waitForCanvas = setTimeout(() => {
      const canvas = gmpMapElement.shadowRoot?.querySelector('canvas');
      if (canvas) {
        canvas.style.cursor = 'crosshair'; // ✅ change to any cursor
        clearInterval(waitForCanvas);
      }
    }, 10000);

    const { Map3DElement, Marker3DInteractiveElement, PopoverElement } =
      await window.google.maps.importLibrary("maps3d");

    let url = ''
    let position = props.mapReference?.getCenter?.()

    const markerTemplate = buildMarkerTemplate(url, '#1d1d1d', 1);
    const popover = new PopoverElement();
    const header = document.createElement("span");
    header.ariaLabel = `This is marker ${1}: ${'test 1'} `;
    header.slot = "header";
    popover.append(header);
    popover.append(`${1}. ${'test 1'} `);

    markerRef = new Marker3DInteractiveElement({
      title: 'Text',
      position: { lat: position?.lat(), lng: position?.lng() },
      gmpPopoverTargetElement: popover,
    });

    markerRef.append(markerTemplate);
    props.mapReferenceThreed.append(markerRef);
    props.mapReferenceThreed.append(popover);
  }

  useEffect(() => {
    if (!props.mapReferenceThreed) return;

    mapFunction()
    const handleMouseMove = (e) => {
      if (e.position) {
        console.log(e.position.lat, e.position.lng);
        markerRef.position = { lat: e.position.lat, lng: e.position.lng }
      }
    };

    const gmpMap = document.querySelector("gmp-map-3d");

    props.mapReferenceThreed.addEventListener("gmp-click", handleMouseMove);
    // gmpMap.addEventListener("gmp-pointermove", handleMouseMove);
    // props.mapReferenceThreed.addEventListener("gmp-pointermove", handleMouseMove);

    return () => {
      props.mapReferenceThreed.removeEventListener("gmp-click", handleMouseMove);
      // gmpMap.removeEventListener("gmp-pointermove", handleMouseMove);
    };
  }, [props.mapReferenceThreed]);


  return (
    <div>

    </div>
  )
}

const mapStateToProps = state => ({
  mapReferenceThreed: state.mapReferenceThreed,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(ThreeDMarkerDetails)

